// AUTO-GENERATED GraphQL Builder for PaymentTransfer
import * as Builders from '../';
export class PaymentTransferBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  paymentId(){ return this.add('paymentId'); }
  bookingId(){ return this.add('bookingId'); }
  bookingPackageId(){ return this.add('bookingPackageId'); }
  vendorId(){ return this.add('vendorId'); }
  vendorPayoutAccountId(){ return this.add('vendorPayoutAccountId'); }
  transferRef(){ return this.add('transferRef'); }
  amount(){ return this.add('amount'); }
  feeAmount(){ return this.add('feeAmount'); }
  onHold(){ return this.add('onHold'); }
  onHoldUntil(){ return this.add('onHoldUntil'); }
  status(){ return this.add('status'); }
  reversedAmount(){ return this.add('reversedAmount'); }
  settlementRef(){ return this.add('settlementRef'); }
  processedDate(){ return this.add('processedDate'); }
  kind(){ return this.add('kind'); }
  ledgerEntryId(){ return this.add('ledgerEntryId'); }
  isSimulated(){ return this.add('isSimulated'); }
  settlementStatus(){ return this.add('settlementStatus'); }
  failureReason(){ return this.add('failureReason'); }
  rawJson(){ return this.add('rawJson'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  payment(b?:(q:Builders.PaymentBuilder)=>void){
    if(this.depth>=5||this.v.has('payment'))return this;
    this.v.add('payment');
    const n=new Builders.PaymentBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`payment { ${inner} }`);
    return this;
  }

  booking(b?:(q:Builders.BookingBuilder)=>void){
    if(this.depth>=5||this.v.has('booking'))return this;
    this.v.add('booking');
    const n=new Builders.BookingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`booking { ${inner} }`);
    return this;
  }

  bookingPackage(b?:(q:Builders.BookingPackageBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPackage'))return this;
    this.v.add('bookingPackage');
    const n=new Builders.BookingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackage { ${inner} }`);
    return this;
  }

  vendor(b?:(q:Builders.VendorBuilder)=>void){
    if(this.depth>=5||this.v.has('vendor'))return this;
    this.v.add('vendor');
    const n=new Builders.VendorBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendor { ${inner} }`);
    return this;
  }

  vendorPayoutAccount(b?:(q:Builders.VendorPayoutAccountBuilder)=>void){
    if(this.depth>=5||this.v.has('vendorPayoutAccount'))return this;
    this.v.add('vendorPayoutAccount');
    const n=new Builders.VendorPayoutAccountBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`vendorPayoutAccount { ${inner} }`);
    return this;
  }

  ledgerEntry(b?:(q:Builders.LedgerEntryBuilder)=>void){
    if(this.depth>=5||this.v.has('ledgerEntry'))return this;
    this.v.add('ledgerEntry');
    const n=new Builders.LedgerEntryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`ledgerEntry { ${inner} }`);
    return this;
  }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  ledgerEntryList(b?:(q:Builders.LedgerEntryBuilder)=>void){
    if(this.depth>=5||this.v.has('ledgerEntryList'))return this;
    this.v.add('ledgerEntryList');
    const n=new Builders.LedgerEntryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`ledgerEntryList { ${inner} }`);
    return this;
  }

  reverseLedgerEntry(b?:(q:Builders.LedgerEntryBuilder)=>void){
    const n=new Builders.LedgerEntryBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`ledgerEntryList { ${inner} }`);
    return this;
  }
}
